import React from "react";
import { Routes, Route } from "react-router-dom";

import BasicLayout from "_common/component/Layout/BasicLayout";
import NoFooterLayout from "_common/component/Layout/NoFooterLayout";
import UnAuthLayout from "_common/component/Layout/UnAuthLayout";
import PageNotfound from "_common/component/PageNotfound";

// auth
import LoginPage from "pages/Auth/Login";
import RegisterPage from "pages/Auth/Register";

import { MiddlewareRouter } from "routers/MiddlewareRouter";
import CheckAuth from "routers/CheckAuth";
import MemberPage from "pages/Member";
import ListHistoryBalance from "pages/Wallet/ListHistoryBalance";
import Deposit from "pages/Wallet/Deposit/Deposit";

import HomeUnAuth from "pages/HomeUnAuth";
import WalletPage from "pages/Wallet";
import ReportPage from "pages/Report";
import MarketListPage from "pages/Market";
import Recharge from "pages/Wallet/Deposit/Recharge";
import KYC from "pages/Member/KYC";
import UpdateUser from "pages/Member/UpdateUser";
import Password from "pages/Member/Password";
import Service from "pages/Service";
import WithdrawSubmit from "pages/Wallet/Withdraw/WithdrawSubmit";
import Exchange from "pages/Wallet/Exchange";
import Introduction from "pages/Member/Introduction";
import KYCFirst from "pages/Member/KYC/KYCFirst";
import AddBankCard from "pages/Wallet/Bank/AddBankCard";
import CheckAuthHome from "routers/CheckAuthHome";
import UserInfoPage from "pages/Member/UserInfo";
import WalletPassword from "pages/Member/WalletPassword";
import WithdrawBank from "pages/Wallet/WithdrawBank/WithdrawSubmit";
import Language from "pages/Member/Language";
import FundPage from "pages/Fund";
import FundDetail from "pages/Fund/FundDetail";
import FundHistory from "pages/Fund/FundHistory";
import AddBankForm from "pages/Wallet/Bank/AddBankForm";
import WalletAddress from "pages/Wallet/WalletAddress";
import WalletList from "pages/Wallet/WalletAddress/WalletList";
import ContractPage from "pages/Contract";
import DepositBank from "pages/Wallet/Deposit/DepositBank";

import Transfer from "pages/Wallet/Transfer";
import MarketDetailPage from "pages/MarketDetail";
import NewsPage from "pages/News";
import NewsDetail1 from "pages/News/NewsDetail1";
import NewsDetail2 from "pages/News/NewsDetail2";
import NewsDetail3 from "pages/News/NewsDetail3";
import NewsDetail4 from "pages/News/NewsDetail4";
import HelpDetail from "pages/Help/HelpDetail";
import HelpPage from "pages/Help";
import VipPage from "pages/Vip";
import RankPage from "pages/Rank";
import SharePage from "pages/Share";
import SavingPage from "pages/Saving";
import ComingSoon from "_common/component/ComingSoon";
import HomePage from "pages/Home";
import Welcome from "pages/Welcome";
import KYCStep1 from "pages/Member/KYC/KYCStep1";
import KYCStep2 from "pages/Member/KYC/KYCStep2";
import HistoryFeaturePage from "pages/Feature/HistoryFeaturePage";
import KYCStep3 from "pages/Member/KYC/KYCStep3";
import KYCStep4 from "pages/Member/KYC/KYCStep4";

export function Routers() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <CheckAuthHome>
            <UnAuthLayout />
          </CheckAuthHome>
        }
      >
        <Route index element={<HomeUnAuth />} />
        <Route path="/m" element={<Welcome />} />
        <Route path="/cskh" element={<Service />} />
      </Route>
      <Route path="/" element={<BasicLayout />}>
        <Route path="language" element={<Language />} />
        <Route path="vip" element={<VipPage />} />
        <Route path="rank" element={<RankPage />} />
        <Route path="invite" element={<SharePage />} />
        <Route path="saving" element={<SavingPage />} />
        <Route path="coming-soon" element={<ComingSoon />} />
        <Route path="news">
          <Route index element={<NewsPage />} />
          <Route path="detail/1" element={<NewsDetail1 />} />
          <Route path="detail/2" element={<NewsDetail2 />} />
          <Route path="detail/3" element={<NewsDetail3 />} />
          <Route path="detail/4" element={<NewsDetail4 />} />
        </Route>
        <Route path="help">
          <Route index element={<HelpPage />} />
          <Route path="detail/1" element={<HelpDetail />} />
        </Route>
        <Route path="market">
          <Route index element={<MarketListPage />} />
          <Route path="detail" element={<MarketDetailPage />} />
        </Route>
        <Route path="introduction" element={<Introduction />} />
        <Route path="contract">
          <Route index element={<ContractPage />} />
          <Route path="history" element={<HistoryFeaturePage />} />
        </Route>
      </Route>

      <Route
        path="/board"
        element={
          <MiddlewareRouter>
            <BasicLayout />
          </MiddlewareRouter>
        }
      >
        <Route index element={<HomePage />} />
        <Route path="wallet" element={<WalletPage />} />
        <Route path="fund">
          <Route index element={<FundPage />} />
          <Route path="list" element={<FundPage />} />
          <Route path="history" element={<FundHistory />} />
          <Route path="detail/:id" element={<FundDetail />} />
        </Route>
        <Route path="report" element={<ReportPage />} />
        <Route path="history" element={<ListHistoryBalance />} />
        <Route path="histories/balance" element={<ListHistoryBalance />} />
        <Route path="exchange" element={<Exchange />} />
      </Route>

      <Route
        path="/member"
        element={
          <MiddlewareRouter>
            <NoFooterLayout />
          </MiddlewareRouter>
        }
      >
        <Route index element={<MemberPage />} />
        <Route path="info" element={<UserInfoPage />} />
        <Route path="kyc">
          <Route index element={<KYC />} />
          <Route path="first" element={<KYCFirst />} />
          <Route path="step1" element={<KYCStep1 />} />
          <Route path="step2" element={<KYCStep2 />} />
          <Route path="step3" element={<KYCStep3 />} />
          <Route path="step4" element={<KYCStep4 />} />
        </Route>
        <Route path="update-profile" element={<UpdateUser />} />
        <Route path="bank" element={<AddBankCard />} />
        <Route path="bank/submit" element={<AddBankForm />} />
        <Route path="wallet" element={<WalletList />} />
        <Route path="add-wallet" element={<WalletAddress />} />
        <Route path="language" element={<Language />} />

        <Route path="password" element={<Password />} />
        <Route path="wallet-password" element={<WalletPassword />} />
        <Route path="recharge" element={<Recharge />} />
        <Route path="transfer" element={<Transfer />} />
        <Route path="deposit" element={<Deposit />} />
        <Route path="deposit-bank" element={<DepositBank />} />
        <Route path="withdraw">
          <Route index element={<WithdrawSubmit />} />
          <Route path="submit" element={<WithdrawSubmit />} />
          <Route path="bank/submit" element={<WithdrawBank />} />
        </Route>
      </Route>

      <Route
        path="auth"
        element={
          <CheckAuth>
            <UnAuthLayout />
          </CheckAuth>
        }
      >
        <Route path="login" element={<LoginPage />} />
        <Route path="register" element={<RegisterPage />} />
      </Route>
      <Route path="*" element={<PageNotfound />} />
    </Routes>
  );
}
